<div class="h-full">
    <mat-card class="mat-elevation-z0 px-5 pb-3 h-full flex flex-col">
        <mat-card-title class="flex justify-content-between mt-1">
            <div class="text-xl font-bold">{{ 'txPlaning.dutyRoster' | translate }}</div>
            <div>
                <span *ngIf="reports$ | async as reports" class="mr-2">
                    <button mat-icon-button class="tx-pdf-button" color="accent" type="button"
                        [disabled]="loadingReport" (click)="stopPropagation($event)" [matMenuTriggerFor]="reportMenu">
                        <fa-icon *ngIf="!loadingReport" icon="file-pdf" class="large-icon"></fa-icon>
                        <fa-icon *ngIf="loadingReport" icon="spinner" class="large-icon" [spin]="true"
                            disabled></fa-icon>
                    </button>
                    <mat-menu #reportMenu="matMenu">
                        <button *ngFor="let report of reports" (click)="downloadReport(report)" mat-menu-item>
                            {{ report.report_name }}
                        </button>
                    </mat-menu>
                </span>
                <button *ngIf="DeleteMode" class="mr-2 tx-cancel-button" mat-icon-button (click)="abortDeleteMode()">
                    <fa-icon icon="times" class="large-icon"></fa-icon>
                </button>
                <button class="mr-2 tx-delete-button" [ngClass]="{ 'tx-delete-button-confirm': DeleteMode }"
                    mat-icon-button (click)="toggleDeleteMode()">
                    <fa-icon class="large-icon" [icon]="DeleteMode ? 'check' : 'trash'"></fa-icon>
                </button>
                <button class="tx-settings-button" mat-icon-button (click)="openPlansDialog()">
                    <fa-icon icon="cog" class="large-icon"></fa-icon>
                </button>
            </div>
        </mat-card-title>
        <mat-card-subtitle>
            <!-- Unwrapped out here so the header can show the count from the same subscription.
                 A second `| async` would issue a second getWfGroups request. -->
            <div *ngIf="myTabStateService.TabStates$ | async as TabStates">
              <ng-container *ngIf="workflowGroups$ | async as workflowGroups">
                <mat-accordion>
                    <mat-expansion-panel class="mat-elevation-z0" hideToggle (opened)="onTabOpen('f2')"
                        (closed)="onTabClose('f2')" [expanded]="TabStates.f2 == null || TabStates.f2 == true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div class="flex space-x-2">
                                    <div class="ml-1">
                                        <div class="transition-all rotate-0 {{ TabStates.f2 ? 'rotate-90' : '' }}">
                                            <fa-icon icon="chevron-right"></fa-icon>
                                        </div>
                                    </div>
                                    <div class="text-xl font-bold">
                                        {{ 'general.filter' | translate }}
                                    </div>
                                    <!-- Inside mat-panel-title so an active filter stays visible
                                         while the panel is collapsed. -->
                                    <div class="flex items-center text-sm"
                                         [class.font-bold]="(SelectedGroups?.length ?? 0) < workflowGroups.length"
                                         [class.text-red-600]="(SelectedGroups?.length ?? 0) < workflowGroups.length">
                                        {{ SelectedGroups?.length ?? 0 }} / {{ workflowGroups.length }}
                                    </div>
                                </div>
                                <!-- Alle/Keine live in the header row so they take no extra line.
                                     stopPropagation keeps the click from toggling the panel. -->
                                <div class="flex items-center space-x-2 ml-auto mr-2">
                                    <button mat-stroked-button class="compact-select-btn"
                                            (click)="$event.stopPropagation(); setAllGroups(true, workflowGroups)">
                                        {{ 'general.selectAll' | translate }}
                                    </button>
                                    <button mat-stroked-button class="compact-select-btn"
                                            (click)="$event.stopPropagation(); setAllGroups(false, workflowGroups)">
                                        {{ 'general.selectNone' | translate }}
                                    </button>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <!-- Erweiterer Filter-Inhalt -->

                        <!-- Bestehende Gruppen-Chips (nur wenn Gruppen vorhanden) -->
                        <div class="mb-4">
                            <mat-chip-list multiple>
                                <mat-chip *ngFor="let group of workflowGroups" class="workflow-chip"
                                    [selected]="SelectedGroups.includes(group.id)"
                                    [color]="SelectedGroups.includes(group.id) ? 'primary' : undefined"
                                    (click)="toggleChip(group.id)">
                                    {{ group.name }}
                                </mat-chip>
                            </mat-chip-list>
                        </div>

                        <div>
                            <!-- Neuer Nutzer-Filter (unabhängig von Gruppen) -->
                            <div>

                                <!-- Nutzer-Select mit Suchfunktion -->
                                <mat-form-field class="w-full" appearance="outline">
                                    <mat-label>{{ 'txPlaning.filterByUsers' | translate }}</mat-label>
                                    <mat-select #userSelect name="userFilterSelect" id="userFilterSelect"
                                        [(ngModel)]="SelectedUsers" (selectionChange)="onUsersSelected($event.value)"
                                        multiple>

                                        <!-- Suchfeld -->
                                        <mat-option>
                                            <ngx-mat-select-search [formControl]="searchControlUsers"
                                                [placeholderLabel]="'txPlaning.searchUsers' | translate"
                                                [noEntriesFoundLabel]="'txPlaning.noUsersFound' | translate"
                                                (keyup)="onSearchUsers($event)">
                                            </ngx-mat-select-search>
                                        </mat-option>

                                        <!-- Nutzer-Optionen -->
                                        <mat-option *ngFor="let user of filteredUsersArray" [value]="user.value">
                                            {{ user.label }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-icon matSuffix *ngIf="SelectedUsers && SelectedUsers.length > 0"
                                        class="cursor-pointer" (click)="clearUserFilter(); $event.stopPropagation()">
                                        close
                                    </mat-icon>
                                </mat-form-field>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
              </ng-container>
            </div>

        </mat-card-subtitle>
        <mat-card-content *ngIf="workflows$ | async as workflows" class="flex-grow overflow-hidden">
            <div id="calendar" class="h-full flex flex-col relative">
                <h1 class="text-center mt-0">{{ currentDateRangeText }}</h1>
                <div class="datepicker-container">
                    <input #dateInput [matDatepicker]="picker" [formControl]="dateControl"
                        class="w-0 p-0 border-0 m-0 invisible" (dateChange)="onDateSelected($event)">
                    <mat-datepicker #picker></mat-datepicker>
                </div>
                <div class="flex-grow overflow-hidden relative">
                    <full-calendar #calendar [deepChangeDetection]="true" [options]="CalendarOptions"
                        class="h-full"></full-calendar>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>
